import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  heading: string;
  content: string;
  content1: string;
  button1Text: string;
  button2Text: string;
}

@Component({
  selector: 'app-dialog-yes-or-no',
  templateUrl:'dialog-yes-or-no.component.html',

  styles:[`
  .flex-gap {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 30px;
  }
  `]
})

export class OpenDialogYesOrNo {

  constructor(
    public dialogRef: MatDialogRef<OpenDialogYesOrNo>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

    onNo(): void {
    this.dialogRef.close("close");
  }
  onYes(): void {
    this.dialogRef.close("dontClose");
  }

}